import { LicenseFeature, LicenseFeatures, LicenseTier, getLicenseTierFeature } from 'model';
import { useContext, createContext } from 'react';

export const LicenseContext = createContext<LicenseTier | undefined>(undefined);

/**
 * Hook to get a license feature value
 * @param { LicenseFeature } feature feature to check
 * @returns { boolean | number | undefined } the value for the feature or undefined if the license is not loaded yet
 */
export function useLicenseFeature<T extends LicenseFeature>(feature: T): LicenseFeatures[T] | undefined {
	const tier = useContext(LicenseContext);
	if (tier === undefined) {
		return undefined;
	}
	return getLicenseTierFeature(tier, feature);
}
